import "./Loader.css";

const Loader = () => {
  return (
    <div className="loaderWpr">
      <span className="loader"></span>
    </div>
  );
};

export default Loader;
